export const landingRoute = {
  home: '/',
  features: '/features',
  pricing: '/pricing',
  about: '/about',
  privacyPolicy: '/privacy-policy',
  termsOfService: '/terms-of-service',
  cookiePolicy: '/cookie-policy',
};
